import React from "react";

import { OnlineLink } from "components";
import { getFullName } from "helpers";

import styles from "../search.module.scss";

export const userResultItem = (obj): { [key: string]: any } => {
	return (
		<div
			className={`${styles.wrappSearchInfo} flex-wrap`}
			style={{ justifyContent: "flex-start" }}
		>
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Name:</p>
					<p className="mb-0">
						<OnlineLink
							to={`/system-setup/users/${obj.id}`}
							target="_blank"
							style={{ marginLeft: "15px" }}
						>
							{getFullName(obj)}
						</OnlineLink>
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Agent Office:</p>
					<div className={styles.content}>
						{obj.company?.id && (
							<p className="mb-0">
								<OnlineLink
									to={`/system-setup/agent-office-setup/edit-agent-office/${obj.company?.id}/general-info`}
									target="_blank"
								>
									{obj.company?.name}
								</OnlineLink>
							</p>
						)}
					</div>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Email:</p>
					<p className={styles.content}>{obj.email}</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Role:</p>
					<p className={styles.content}>
						{obj.assignee?.first_name} {obj.role?.name}
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>User Status:</p>
					<p className={styles.content}>
						{!obj.status ? "Active" : "Inactive"}
					</p>
				</div>
			}
		</div>
	);
};
